export default __webpack_public_path__ + "static/imageFifthSection-7ecdbfcd4e895ea14a39ead7116dd6ec.svg";